import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import MarketOpportunity from './components/MarketOpportunity';
import IndustryProblem from './components/IndustryProblem';
import OurSolution from './components/OurSolution';
import RiskManagement from './components/RiskManagement';
import Ecosystem from './components/Ecosystem';
import Urgency from './components/Urgency';
import SeminarTopics from './components/SeminarTopics';
import Recommendation from './components/Recommendation';
import FinalCTA from './components/FinalCTA';
import CompanyProfile from './components/CompanyProfile';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <MarketOpportunity />
      <IndustryProblem />
      <OurSolution />
      <RiskManagement />
      <Ecosystem />
      <Urgency />
      <SeminarTopics />
      <Recommendation />
      <FinalCTA />
      <CompanyProfile />
      <Footer />
    </div>
  );
}
